import React from 'react'
import "./datatable.scss";
import { DataGrid } from "@mui/x-data-grid";
import { useState as uState, useEffect as uEffect } from "react";


export default function orderDelivery() {
    const [data, setData] = uState([]);
    const [status, setStatus] = uState('')
    
    const handleSelectChange = (event) => {
        setStatus(event.target.value);
    };

    uEffect(() => {
        fetch("http://localhost:8000/order/orderDelivery", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
        }).then((response) => response.json()).then((data) => setData(data));
    }, []);

    const handleDelivery = (UserId) => {
        fetch("http://localhost:8000/order/delStatus", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                deliveryStatus: status,
                userId:UserId
            })
        })
    };
    const filteredProducts = data.filter(product => product.hasOwnProperty('ProductTitle'));

    function getRowId(filteredProducts) {
        return filteredProducts.UserId;
    }
    const productColumns = [
        { field: "UserId", headerName: "Id", width: 100 },
        { field: "UserEmail", headerName: "Email", width: 100 },
        { field: "ProductTitle", headerName: "Title", width: 100 },
        { field: "ProductQuantity", headerName: "Quantity", width: 100 },
        { field: "ProductAmount", headerName: "Amount", width: 100 },
        { field: "ProductType", headerName: "Type", width: 100 },
        { field: "DeliveryStatus", headerName: "Status", width: 150 },
    ];


    const actionColumn = [
        {
            field: "action",
            headerName: "Action",
            width: 350,
            renderCell: (params) => {
                const { UserId } = params.row;
                return (
                    <form onSubmit={() => handleDelivery(UserId)} className="cellAction">
                        <select className="deleteButton" value={status} onChange={handleSelectChange}>  
                            <option >Select</option>                            
                            <option value='delivered'>Delivered</option>
                            <option value='pending'>Pending</option>
                            <option value='cancel'>Cancelled</option>
                        </select>
                        <button type='submit' className='btn btn-success'>Update Status</button>                        
                    </form>
                );
            },
        },
    ];
    return (
        <>

            <div className="datatable">
                <DataGrid
                    className="datagrid"
                    getRowId={getRowId}
                    rows={filteredProducts}
                    columns={productColumns.concat(actionColumn)}
                    pageSize={9}
                    rowsPerPageOptions={[9]}
                    checkboxSelection
                />
            </div>



        </>
    )
}
